import { CommunicationOption } from 'models/profile-settings.model';

export const updateCommunicationOptions = (
  options: CommunicationOption[],
  id: string,
  value: boolean,
): CommunicationOption[] => {
  if (id === 'STR_PAPERLESS' && value) {
    return options.map((opt) => {
      switch (opt.labelId) {
        case 'STR_PAPERLESS':
          return { ...opt, value };
        case 'STR_PERSONALIZED_EMAIL':
          return { ...opt, value: true };
        default:
          return opt;
      }
    });
  }

  if (id === 'STR_PERSONALIZED_EMAIL' && !value) {
    const paperlessOption = options.find(
      (opt) => opt.labelId === 'STR_PAPERLESS',
    );
    const isPaperlessYes = paperlessOption?.value === true;
    if (isPaperlessYes) {
      return options.map((opt) => {
        switch (opt.labelId) {
          case 'STR_PERSONALIZED_EMAIL':
            return { ...opt, value };
          case 'STR_PAPERLESS':
            return { ...opt, value: false };
          default:
            return opt;
        }
      });
    }
  }

  return options.map((opt) => (opt.labelId === id ? { ...opt, value } : opt));
};
